"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleValueChange = exports.getShowError = exports.hideWhileTyping = exports.inputWarning = exports.noError = void 0;
const ValidationResponse_1 = require("./ValidationResponse");
exports.noError = [
    ValidationResponse_1.ValidationResponse.VALID,
    ValidationResponse_1.ValidationResponse.EMPTY,
    ValidationResponse_1.ValidationResponse.EMAIL_WARNING_TYPO,
];
exports.inputWarning = [ValidationResponse_1.ValidationResponse.EMAIL_WARNING_TYPO];
exports.hideWhileTyping = [
    ValidationResponse_1.ValidationResponse.ADDRESS_INVALID_SHORT,
    ValidationResponse_1.ValidationResponse.CITY_INVALID_SHORT,
    ValidationResponse_1.ValidationResponse.EMAIL_INVALID,
    ValidationResponse_1.ValidationResponse.EMAIL_WARNING_TYPO,
    ValidationResponse_1.ValidationResponse.EMPTY,
    ValidationResponse_1.ValidationResponse.FIRSTNAME_INVALID_SHORT,
    ValidationResponse_1.ValidationResponse.FULL_SSN_INVALID,
    ValidationResponse_1.ValidationResponse.FULL_SSN_SHORT,
    ValidationResponse_1.ValidationResponse.LASTNAME_INVALID_SHORT,
    ValidationResponse_1.ValidationResponse.LAST_FOUR_SSN_SHORT,
    ValidationResponse_1.ValidationResponse.PHONE_NUMBER_INVALID,
    ValidationResponse_1.ValidationResponse.ZIP_INVALID,
];
const getShowError = (r) => {
    return !exports.noError.includes(r);
};
exports.getShowError = getShowError;
const handleValueChange = (validationResponse, setError) => {
    if (!exports.hideWhileTyping.includes(validationResponse)) {
        setError(validationResponse);
    }
    else {
        setError(ValidationResponse_1.ValidationResponse.EMPTY);
    }
};
exports.handleValueChange = handleValueChange;
